import React from 'react';

const StripeManual = () => {
  return (
    <div className="mx-6">
      <div className="my-6">
        <h1>Stripeに新しく登録してピッタプットと連携する</h1>
      </div>
      <div>
        <span className="title">
          1)
          <a
            href="https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_HMjw0lVlIUzcj0RMFSgE5sfRkizhNDsC&scope=read_write"
            target="_blank"
            rel="noopener noreferrer"
          >
            こちら
          </a>
          よりStripe連携ページを開きます
        </span>
      </div>
      <div className="mt-6">
        <span className="title">2) 既にStripeアカウントをお持ちの方は、画面右上の「サインイン」よりログインしてください。</span>
      </div>
      <div className="mb-6">
        <span className="title ml-6">初めてStripeを利用する方は、そのまま手順3に進んでください。</span>
      </div>
      <div>
        <span className="title">3) 「コンプライアンス関連の質問」に回答し、「提出」ボタンを押してください（下図参考）</span>
      </div>
      <div>
        <span className="body-1 ml-6">※解説</span>
      </div>
      <div>
        <span className="body-1 ml-6">1つ目の質問については、ピッタプットではクレジットカード情報を保持しないため「いいえ」となります。</span>
      </div>
      <div>
        <span className="body-1 ml-6">2つ目の質問については、ピッタプットでは購入時の身元特定のための付加的な検証を行っていないため「いいえ」となります。</span>
      </div>
      <div>
        <span className="body-1 ml-6">3つ目の質問については、ピッタプットでは購入時にクレジットカードのセキュリティコード（CVC）を要求しているため「はい」となります。</span>
      </div>
      <div>
        <span className="body-1 ml-6">4つ目の質問については、ピッタプットはデジタルコンテンツの配信のみを行っているため「いいえ」となります。</span>
      </div>
      <div>
        <span className="body-1 ml-6">5つ目の質問については、お客様自身によって異なるので、当てはまる回答を行ってください。</span>
      </div>
      <div className="my-4" style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src="image/stripe_manual/compliance.PNG"
          alt="コンプライアンス関連の質問"
          style={{ maxWidth: '600px', width: '100%' }}
        />
      </div>
      <div className="mt-6">
        <span className="title">4) 「本番環境利用の申請」に必要情報を入力してください。</span>
      </div>
      <div className="my-6">
        <span className="title">5) 最後に、「このアカウントへのアクセスを許可する」をクリックすると、ピッタプットにてアカウント連携情報を確認し、登録完了となります。</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          style={{
            backgroundColor: 'teal',
            color: 'white',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            border: 'none',
          }}
          onClick={() => {
            window.location.href = '/'; // 簡易的なホームに戻る処理
          }}
        >
          ホームに戻る
        </button>
      </div>
    </div>
  );
};

export default StripeManual;